export default __webpack_public_path__ + "static/20_34-b88ca1d0d53123a0d46b832c119ae9b0.png";